module.exports = __webpack_public_path__ + "first-10_raised_print.jpg?ff281993d469a0a9c878392a8ef9c779";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-10_raised_print.jpg
// module id = 447
// module chunks = 0